import axios from 'axios';
import { EnvironmentVariables } from 'models/environment';
import env from 'modules/env/env';

import { authHandler } from './middleware/auth-handler';
import { statusHandlerError, statusHandlerSuccess } from './middleware/status-handler';

const createHttpClient = (baseURL: string | undefined) => {
  const client = axios.create({ baseURL });

  client.interceptors.response.use(statusHandlerSuccess, statusHandlerError);
  client.interceptors.request.use(authHandler);

  return client;
};

const httpClient = createHttpClient(env(EnvironmentVariables.identityHost));

export { httpClient };